// extracted by mini-css-extract-plugin
export var content = "index-module--content--Znuqr";
export var inner = "index-module--inner--Yzxs2";
export var logo = "index-module--logo--k9BOq";
export var lookDetail = "index-module--lookDetail--EGl2D";
export var p1 = "index-module--p1--rA23B";